import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  OnDestroy,
  effect,
  input,
  signal,
} from '@angular/core';

import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'sia-phone-button',
  templateUrl: './sia-phone-button.component.html',
  styleUrls: ['./sia-phone-button.component.scss'],
  standalone: true,
  imports: [MatIconButton],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaPhoneButtonComponent implements OnDestroy {
  readonly isMobile = input<boolean>(true);
  readonly telephone = input<string>('');

  readonly isVisible = signal(false);
  private readonly telephoneValue = signal('');

  @HostListener('window:unload')
  ngOnDestroy() {
    this.telephoneValue.set('');
    this.isVisible.set(false);
  }

  constructor() {
    effect(() => {
      const currentTelephone = this.telephone();
      const hasTelephone = !!currentTelephone;

      this.telephoneValue.set(hasTelephone ? currentTelephone : '');
      this.isVisible.set(hasTelephone);
    });
  }

  openUserCall() {
    const phoneToDial = this.telephoneValue();

    if (phoneToDial) {
      document.location.href = 'tel:' + phoneToDial;
    }
  }
}
